import React from "react";
// i18n
import "src/locales/i18n";
// scroll bar
import "simplebar-react/dist/simplebar.min.css";
// map
import "src/utils/mapboxgl";
import "mapbox-gl/dist/mapbox-gl.css";
// editor
import "react-quill/dist/quill.snow.css";
// slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// lazy image
import "react-lazy-load-image-component/src/effects/blur.css";
// fingerprint js
import {FingerprintProvider} from "@fingerprint/react";
// @mui
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
// context
import {SettingsProvider} from "src/context/settings";
// redux
import ReduxProvider from "src/redux/redux-provider";
// routes
import {NavigationProvider} from "src/routes/context";
import Router from "src/routes/sections";
// theme
import ThemeProvider from "src/theme";
// hooks
import useMeta from "src/hooks/use-meta";
import useGTM from "src/hooks/use-gtm";
import useChunkLoad from "src/hooks/use-chunk-load";
import {useScrollToTop} from "src/hooks/use-scroll-to-top";
// components
import MotionLazy from "src/components/animate/motion-lazy";
import {SnackbarProvider} from "src/components/snackbar";
// auth
import {AuthConsumer, AuthProvider} from "src/auth/context/jwt";
//
import {FINGERPRINT_KEY} from "src/config-global";

// ----------------------------------------------------------------------

export default function App() {
    useMeta();
    useGTM();
    useChunkLoad();

    useScrollToTop();

    // ----------------------------------

    return (
        <FingerprintProvider
            apiKey={FINGERPRINT_KEY}
            endpoints={[
                "https://metrics.shipsaving.com",
            ]}
        >
            <NavigationProvider>
                <AuthProvider>
                    <ReduxProvider>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <SettingsProvider
                                defaultSettings={{
                                    themeMode: "light", // 'light' | 'dark'
                                    themeDirection: "ltr", //  'rtl' | 'ltr'
                                    themeContrast: "default", // 'default' | 'bold'
                                    themeLayout: "vertical", // 'vertical' | 'horizontal' | 'mini'
                                    themeColorPresets: "default", // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
                                    themeStretch: false
                                }}
                            >
                                <ThemeProvider>
                                    <MotionLazy>
                                        <SnackbarProvider>
                                            <AuthConsumer>
                                                <Router/>
                                            </AuthConsumer>
                                        </SnackbarProvider>
                                    </MotionLazy>
                                </ThemeProvider>
                            </SettingsProvider>
                        </LocalizationProvider>
                    </ReduxProvider>
                </AuthProvider>
            </NavigationProvider>
        </FingerprintProvider>
    );
}
